import { render } from "./ProgramInnerPage.vue?vue&type=template&id=0577473c&scoped=true"
import script from "./ProgramInnerPage.vue?vue&type=script&lang=js"
export * from "./ProgramInnerPage.vue?vue&type=script&lang=js"

import "./ProgramInnerPage.vue?vue&type=style&index=0&id=0577473c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0577473c"]])

export default __exports__